/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ThemeTile',['pixi', 'absolute', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile', 'util/SettingsManager'],

	function (PIXI, Absolute, _, SolitaireGameMode, MenuTile, SettingsManager) {

		var ThemeTile = function (config) {
			var defaultConfig = {
				labelPosition: {
					"x": Absolute.Coords.x(15),
					"y": Absolute.Coords.y(217)
				}
			};
			this.initThemeTile(_.extend(defaultConfig, config));
		};

		ThemeTile.prototype = Object.create(MenuTile.prototype);

		ThemeTile.prototype.initThemeTile = function (config) {
			MenuTile.call(this, config);
			this.themeId = this.config.themeId;
			this.selectedHighlight = PIXI.Sprite.fromFrame('mainmenu/frame_theme_highlight.png');
			this.selectedHighlight.x = this.selectedHighlight.y = -Absolute.Coords.x(7);
			this.addChild(this.selectedHighlight);
			this.updateState(this.themeId == SettingsManager.getSetting('theme', 'selected'));
			this.initOutline();
		};

		ThemeTile.prototype.initOutline = function () {
			var outLine = new PIXI.Graphics(),
				lineWeight = Absolute.Coords.x(1);
			outLine.beginFill(0xFFFFFF, 0);
			outLine.lineStyle(lineWeight, 0xffffff, 1);
			outLine.drawRect(0, 0, this.width, this.height);
			outLine.endFill();
			this.addChild(outLine);
			this.imageOutline = outLine;
		};

		ThemeTile.prototype.handleClick = function () {
			SettingsManager.setSetting('theme', 'selected', this.themeId);
			this.config.themeChangeCallback(this.themeId);
		};

		ThemeTile.prototype.updateState = function (selected) {
			this.selected = selected;
			this.selectedHighlight.visible = selected;
		};

		ThemeTile.prototype.onShow = function () {

		};

		return ThemeTile;

	});

